import jadeTheme from '@stone-payments/jade-design-tokens/cjs/stone';
import styled from "styled-components";

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${jadeTheme.global.space[100]};
`;
